import { createSelector } from 'reselect';

export const getSelectedAsset = ({ crossAssetAnalysisV2 }) =>
    crossAssetAnalysisV2?.selectedAsset;

export const getSelectedAssetCapability = ({ crossAssetAnalysisV2 }) =>
    crossAssetAnalysisV2?.selectedAssetCapability;

export const getSelectedAssetSubscription = ({ crossAssetAnalysisV2 }) =>
    crossAssetAnalysisV2?.subscriptionInfo;

export const getKpiLoadingStatus = ({ crossAssetAnalysisV2 }) =>
    crossAssetAnalysisV2?.kpiList?.loadingStatus;

export const getOffGraphSignals = ({ crossAssetAnalysisV2 }) =>
    crossAssetAnalysisV2?.offGraphSignals || [];

const getSelectedOrganization = ({ generalFilter }) =>
    generalFilter?.selectedFilters?.organizations?.[0];

const getSelectedSites = ({ generalFilter }) => {
    return generalFilter.selectedFilters.sitesChecked ?
        generalFilter.selectedFilters.sites.map((site) => site.siteID) :
        [];
};

export const getSelectedCategory = ({ crossAssetAnalysisV2 }) =>
    crossAssetAnalysisV2?.selectedCategory;

export const getSelectedPowertrainId = ({ crossAssetAnalysisV2 }) =>
    crossAssetAnalysisV2?.selectedPowertrainId;

export const getPowertrainListForBrowser = ({ crossAssetAnalysisV2 }) =>
    crossAssetAnalysisV2?.powertrainList?.data || [];

export const getPowertrainListLoadingStatusForBrowser = ({ crossAssetAnalysisV2 }) =>
    crossAssetAnalysisV2?.powertrainList?.loadingStatus;

const getPowertrainFilterForBrowser = ({ conditionIndicesV2 }) =>
    conditionIndicesV2?.filter?.powertrains;

const getAssetListFilterForBrowser = ({ conditionIndicesV2 }) =>
    conditionIndicesV2?.filter?.assets;

const getHierarchyFilterForBrowser = ({ conditionIndicesV2 }) =>
    conditionIndicesV2?.filter?.hierarchy;

const getHierarchyDataForBrowser = ({ conditionIndicesV2 }) =>
    conditionIndicesV2?.hierarchy?.data;

const getHierarchyLoadingStatusForBrowser = ({ conditionIndicesV2 }) =>
    conditionIndicesV2?.hierarchy?.loadingStatus;

const getAssetOverviewDataForBrowser = ({ conditionIndicesV2 }) =>
    conditionIndicesV2?.assets?.data;

const getAssetOverviewLoadingStatusForBrowser = ({ conditionIndicesV2 }) =>
    conditionIndicesV2?.assets?.loadingStatus;

const getActiveTabForBrowser = ({ conditionIndicesV2 }) =>
    conditionIndicesV2?.selectedTab;

const getGeneralFilterAssetsForBrowser = ({ generalFilter }) =>
    generalFilter?.assets?.data || [];

export const getAssetBrowserPanelModel = createSelector(
    [
        getSelectedAsset,
        getSelectedOrganization,
        getSelectedCategory,
        getSelectedPowertrainId,
        getPowertrainListForBrowser,
        getPowertrainListLoadingStatusForBrowser,
        getPowertrainFilterForBrowser,
        getAssetListFilterForBrowser,
        getHierarchyFilterForBrowser,
        getHierarchyDataForBrowser,
        getHierarchyLoadingStatusForBrowser,
        getAssetOverviewDataForBrowser,
        getAssetOverviewLoadingStatusForBrowser,
        getActiveTabForBrowser,
        getGeneralFilterAssetsForBrowser,
        getSelectedSites
    ],
    (
        selectedAsset,
        selectedOrganization,
        selectedCategory,
        selectedPowertrainId,
        powertrainList,
        powertrainListLoadingStatus,
        powertrainFilter,
        assetListFilter,
        hierarchyFilter,
        hierarchyData,
        hierarchyLoadingStatus,
        assetOverviewData,
        assetOverviewLoadingStatus,
        activeTab,
        generalFilterAssets,
        selectedSites
    ) => ({
        selectedAsset,
        selectedOrganization,
        selectedCategory,
        selectedPowertrainId,
        powertrainList,
        powertrainListLoadingStatus,
        powertrainFilter,
        assetListFilter,
        hierarchyFilter,
        hierarchyData,
        hierarchyLoadingStatus,
        assetOverviewData,
        assetOverviewLoadingStatus,
        activeTab,
        generalFilterAssets,
        selectedSites
    })
);
